import classes from "./Vienna_explore.module.css"
import { useState, useMemo } from "react";
import { Button } from "@mui/material";
import { assetsBaseUrl } from "../../../routes";

const ExploreContent = (props) => {
    const [header] = useState(props.data.header);
    const [text] = useState(props.data.content);
    const pic = useMemo(() => {
        const p = props.data.file1;
        if (!p) return '';
        if (String(p).startsWith('http')) return p;
        const norm = String(p).replace(/\\/g, '/').replace(/^\/+/, '');
        return `${assetsBaseUrl}${norm}`;
    }, [props.data.file1]);

    return (
        <div className={classes.mainC}>
            <div className={classes.head}>{header}</div>
            <div className={classes.body}>
                <div className={classes.bodyleft}>{pic && <img src={pic} alt={header} />}</div>
                <div className={classes.bodyright} style={{ whiteSpace: "pre-line" }}>{text}</div>
            </div>
            <div className={classes.footer}>
                <Button variant="text" onClick={() => props.preview?.(props.data)}>Preview</Button>
                <Button variant="text" color="error" onClick={() => props.delete(props.data.id)}>Delete</Button>
            </div>
        </div>
    );
}

export default ExploreContent;